import React, { useEffect, useMemo, useState } from "react";
import "./Service.css";

export default function Service() {
  const products = useMemo(
    () => [
      {
        id: 1,
        price: "$120",
        bg: "#F6E7B6",
        img: "https://images.unsplash.com/photo-1581605405669-fcdf81165afa?auto=format&fit=crop&w=700&q=80",
        alt: "Yellow backpack",
      },
      {
        id: 2,
        price: "$220",
        bg: "#DCD6FF",
        img: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?auto=format&fit=crop&w=700&q=80",
        alt: "Red backpack",
      },
      {
        id: 3,
        price: "$320",
        bg: "#CFF5EA",
        img: "https://images.unsplash.com/photo-1581605405669-fcdf81165afa?auto=format&fit=crop&w=700&q=80",
        alt: "Dark backpack",
      },
      {
        id: 4,
        price: "$180",
        bg: "#FFD9C7",
        img: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?auto=format&fit=crop&w=700&q=80",
        alt: "Backpack variant",
      },
    ],
    []
  );

  const [start, setStart] = useState(0);

  const visible = useMemo(() => {
    // 3 items visibles comme sur l'image
    const arr = [];
    for (let i = 0; i < 3; i++) {
      arr.push(products[(start + i) % products.length]);
    }
    return arr;
  }, [products, start]);

  const prev = () => setStart((s) => (s - 1 + products.length) % products.length);
  const next = () => setStart((s) => (s + 1) % products.length);

  // auto (léger) pour donner vie — tu peux enlever si tu veux
  useEffect(() => {
    const t = setInterval(() => setStart((s) => (s + 1) % products.length), 5200);
    return () => clearInterval(t);
  }, [products.length]);

  return (
    <section className="serviceWrap-stcd">
      <div className="serviceInner-stcd">
        <div className="serviceGrid-stcd">
          {/* LEFT */}
          <div className="left-stcd">
            <h2 className="title-stcd">
              Gestion <br />
              <span className="titleBold-stcd">de Stock.</span>
            </h2>

            <p className="desc-stcd">
              Grâce à nos outils professionnels, optimisez la gestion de vos stocks et de vos livraisons tout en permettant à vos clients de consulter l’historique de leurs achats.
            </p>

            <div className="btnRow-stcd">
              
              <a className="btnGhost-stcd" href="https://wa.me/+22893410827" style={{textDecoration: 'none'}}>
                <span className="playDot-stcd" aria-hidden="true" />
                Procurez un outil de Gestion.
              </a>
            </div>

            {/* Bottom-left mini carousel */}
            <div className="miniArea-stcd">
              <button className="miniNav-stcd miniPrev-stcd" onClick={prev} aria-label="Previous">
                «
              </button>

              <div className="miniRow-stcd">
                {visible.map((p) => (
                  <div key={p.id} className="miniCard-stcd" style={{ background: p.bg }}>
                    <img className="miniImg-stcd" src={p.img} alt={p.alt} />
                    
                  </div>
                ))}
              </div>

              <button className="miniNav-stcd miniNext-stcd" onClick={next} aria-label="Next">
                »
              </button>
            </div>
          </div>

          {/* RIGHT */}
          <div className="right-stcd">
            <div className="heroWrap-stcd">
              {/* “petales” */}
              <div className="petals-stcd" aria-hidden="true">
                <span className="petal-stcd p1-stcd" />
                <span className="petal-stcd p2-stcd" />
                <span className="petal-stcd p3-stcd" />
                <span className="petal-stcd p4-stcd" />
                <span className="petal-stcd p5-stcd" />
              </div>

              {/* HERO IMAGE */}
              <img
                className="heroImg-stcd"
                src="/site3.jpg"
                alt="Backpack"
              />
            </div>

            {/* Price + colors + rating block (bottom-right) */}
            <div className="meta-stcd">
          
              <div className="ratingRow-stcd">
                <div className="rating-stcd">
                  <span className="ratingBig-stcd">24h</span>
                  <span className="ratingSmall-stcd">/7</span>
                </div>
                <div className="ratingText-stcd">
                  Consulter vos Stocks <br /> & Ventes Partout.
                </div>
              </div>

              <div className="reviewRow-stcd">
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
